<template>


  <footer
      style="background-color: rgb(249, 249, 249);"
      aria-labelledby="footerHeading"
  >

    <h2 id="footerHeading" class="sr-only">Footer</h2>
    <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">

      <div class="mt-12 border-t border-gray-200 pt-4">
        <nav class=" flex flex-wrap justify-center mb-2" aria-label="Footer">
          <div v-for="item in navigation2.main" :key="item.name" class="px-5">
            <a :href="item.href" class="text-base text-gray-400 hover:text-gray-900">
              {{ item.name }}
            </a>
          </div>
        </nav>
        <p class="text-base text-gray-400 xl:text-center">
          &copy; 2021 AgileSuite, Inc. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
const navigation2 = {
  main: [
    { name: 'About', href: '/landing/about' },
    { name: 'Terms', href: '/terms-of-service' },
    { name: 'Privacy', href: '/privacy-policy' },
  ]
}
export default {
  setup() {
    return {
      navigation2,
    }
  },
};
</script>

